export default __webpack_public_path__ + "static/media/restaurante.a9f85911.png";